export default __webpack_public_path__ + "static/about-us-banner-1310-3fe41680efc9dc8d01aa22ae3f7c9196.png";